import { useRouter } from 'next/router';
import { useCallback } from 'react';

const useBookDemo = (): (() => void) => {
  const { asPath, push } = useRouter();

  return useCallback(() => {
    const [bookDemoUrl] = asPath.split('#');
    push(`${ bookDemoUrl }#book-demo`, undefined, { shallow: true });
  }, [asPath, push]);
};

export default useBookDemo;
